
import React, { useEffect, useState } from "react";
import { auth, onAuthStateChanged, signOut, userDoc, onSnapshot } from "../firebase";
import { Link } from "react-router-dom";

export default function Dashboard() {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
      if (!u) return;
      const unsubDoc = onSnapshot(userDoc(u.uid), (snap) => {
        setProfile(snap.data() || null);
      });
      return () => unsubDoc();
    });
    return () => unsub();
  }, []);

  if (!user) {
    return (
      <div style={{padding:20}}>
        <h2>Dashboard</h2>
        <p>Please <Link to="/login">login</Link> to view your dashboard.</p>
      </div>
    );
  }

  const handleLogout = async () => {
    await signOut(auth);
    window.location.href = "/";
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Welcome, {user.email}</h2>
      <pre style={{background:"#f5f5f5", padding:12, borderRadius:8}}>
        {JSON.stringify(profile || {info:"No profile doc yet"}, null, 2)}
      </pre>
      <button onClick={handleLogout}>Logout</button>
    </div>
  );
}
